import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { getISO8601DateStringFromMoment, propExistsAndIsNonEmpty } from '../../utils';

import * as moment from 'moment';

import AirDatepicker, { AirDatepickerOptions } from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';


@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.css']
})
export class CapitanDatePickerComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @Input()
  id: string;

  @Input()
  content: string;

  @Output()
  contentChange = new EventEmitter<string>();

  @Input()
  small = false;

  @Input()
  disabled = false;

  // When true, the field can't be emptied: no "Clear" button and manual clears
  // are rejected (the previous value is re-asserted). Used by required date-range
  // filters (charts) that must always have both bounds.
  @Input()
  required = false;

  @Input()
  minDate = '';

  @Input()
  maxDate = '';

  @Input()
  containerIdOverride = '';

  public datePickerContainerId = '';
  public placeholder = '';

  private pickerObj: AirDatepicker<HTMLElement>;

  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.placeholder = moment('2020-11-12').format('l');
    this.placeholder = this.placeholder.replace('2020', 'yyyy');
    this.placeholder = this.placeholder.replace('11', 'mm');
    this.placeholder = this.placeholder.replace('12', 'dd');
  }

  ngAfterViewInit() {
    if (this.containerIdOverride !== '') {
      this.datePickerContainerId = this.containerIdOverride;
    } else {
      this.datePickerContainerId = this.id + '-datepicker-container';
    }
    this.changeDetectorRef.detectChanges();

    const datePickerButtons: any[] = [
      {
        content: 'Today',
        onClick: (dp) => {
          this.emitAndUpdatePickerForNewDate(
            getISO8601DateStringFromMoment(moment())
          );
          dp.hide();
        }
      }
    ];
    // A required picker offers no "Clear" (the field must never be emptied).
    if (!this.required) {
      datePickerButtons.push({
        content: 'Clear',
        onClick: (dp) => {
          this.emitAndUpdatePickerForNewDate('');
          dp.hide();
        }
      });
    }

    const datePickerOpts: AirDatepickerOptions = {
      locale: localeEn,
      keyboardNav: false,
      autoClose: true,
      container: '#' + this.datePickerContainerId,
      buttons: datePickerButtons,
      dateFormat(date) {
        return moment(date).format('l');
      }
    };

    if (this.minDate !== '') {
      datePickerOpts.minDate = this.minDate;
    }
    if (this.maxDate !== '') {
      datePickerOpts.maxDate = this.maxDate;
    }

    this.pickerObj = new AirDatepicker(
      '#' + this.id,
      datePickerOpts
    );
    if (propExistsAndIsNonEmpty(this.content)) {
      this.pickerObj.selectDate(this.content);
      this.pickerObj.setViewDate(this.content);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // Must specify a time or the browser will use the current time, which may
    // cause the date to shift.
    if (changes.content) {
      if (this.pickerObj) {
        if (propExistsAndIsNonEmpty(changes.content.currentValue)) {
          this.pickerObj.selectDate(changes.content.currentValue);
          this.pickerObj.setViewDate(changes.content.currentValue);
        } else {
          this.pickerObj.clear({silent: true});
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.pickerObj) {
      this.pickerObj.destroy();
    }
  }

  handleDateChange(event) {
    const newDateStr = event.target.value;

    if (newDateStr === '') {
      if (this.required) {
        // A required field can't be cleared: re-assert the current value so the
        // input doesn't end up empty.
        if (this.pickerObj && propExistsAndIsNonEmpty(this.content)) {
          this.pickerObj.selectDate(this.content);
          this.pickerObj.setViewDate(this.content);
        }
        return;
      }
      this.emitAndUpdatePickerForNewDate(newDateStr);
      return;
    }
    let dateMoment = moment(newDateStr, 'l');
    if (dateMoment.isValid() && (dateMoment.year() > 999) && (dateMoment.year() < 10000)) {
      this.emitAndUpdatePickerForNewDate(getISO8601DateStringFromMoment(dateMoment));
      return;
    }
    dateMoment = moment(newDateStr);
    if (dateMoment.isValid() && (dateMoment.year() > 999) && (dateMoment.year() < 10000)) {
      this.emitAndUpdatePickerForNewDate(getISO8601DateStringFromMoment(dateMoment));
      return;
    }
  }

  private emitAndUpdatePickerForNewDate(dateIsoStr: string) {
    if (dateIsoStr !== this.content) {
      this.contentChange.emit(dateIsoStr);
      if (this.pickerObj) {
        if (propExistsAndIsNonEmpty(dateIsoStr)) {
          this.pickerObj.selectDate(dateIsoStr);
          this.pickerObj.setViewDate(dateIsoStr);
        } else {
          this.pickerObj.clear({silent: true});
        }
      }
    }
  }
}
